import React, { Component } from "react";
import Select from "react-select";

import { connect } from "react-redux";
import { difference, isEqual } from "lodash";
import { fetchConversions } from "../../../../store/slices/admin/conversions";

type Props = {
	isEdit: boolean,
	brands: Array<string>,
	conversions: Array<string>,
	cellId: number,
	type: string,
	id: number,
	updateConfig: Function,
	// injected
	dispatch: Function,
	isLoadingBrands: boolean,
	conversionsData: Array<any>,
	isLoadingConversions: boolean,
	isDisabled: boolean,
}

type OptionType = {
	value: string;
	label: string;
};

type State = {
	selectedConversions: OptionType[],
}

class ConversionFilter extends Component<Props, State> {
	// used for passing additional converions on edit page that may not be present in new dataset when fetching current converions
	additionalConversions: Array<string>;
	initConversionsSet: boolean;

	constructor(props: Props) {
		super(props);

		this.additionalConversions = props.conversions;
		this.initConversionsSet = false;

		this.state = {
			selectedConversions: []
		};

		this.onConversionChange = this.onConversionChange.bind(this);
	}

	static defaultProps = {
		isDisabled: false
	}

	componentDidMount() {
		if (this.props.brands.length && this.props.conversions && this.props.conversions.length) {
			const brands = this.props.brands.join(',');
			this.props.dispatch(fetchConversions(brands, this.additionalConversions, false, this.props.cellId));
		}
	}

	componentDidUpdate(prevProps: Props) {
		if (!prevProps.isDisabled && this.props.isDisabled) {
			this.setState({ selectedConversions: [] }, () => {
				this.props.updateConfig(["conversions"], [[]]);
			});
			return;
		}

		const brands = this.props.brands.join(',');
		if (!isEqual(prevProps.brands, this.props.brands)) {
			// this.props.dispatch(fetchConversions(brands, this.additionalConversions, false, this.props.cellId));

			if (prevProps.id === this.props.id && prevProps.brands.length > this.props.brands.length) {
				// If brand is removed, there is no need to fetch tags again, just delete tags for that brand
				const deletedBrands = difference(prevProps.brands, this.props.brands);

				this.setState((prevState, props) => {
					return { selectedConversions: prevState.selectedConversions && prevState.selectedConversions.length ? prevState.selectedConversions.filter(conversionOption => !deletedBrands.includes(conversionOption.value.split('-')[0])) : [] };
				}, () => {
					this.props.updateConfig(["conversions"], [(!this.state.selectedConversions || this.state.selectedConversions.length < 1) ? [] : this.state.selectedConversions.map(item => item.value)]);
				});
			} else {
				this.props.dispatch(fetchConversions(brands, this.additionalConversions, false, this.props.cellId));
			}
		}

		if ((!isEqual(prevProps.conversionsData[this.props.cellId], this.props.conversionsData[this.props.cellId]) || !isEqual(prevProps.conversions, this.props.conversions)) && !this.initConversionsSet) {
			this.initConversionsSet = true;
			this.setInitConverionFilter();
		}

		if (prevProps.type !== this.props.type) {
			this.setState({ selectedConversions: [] }, () => {
				this.props.dispatch(fetchConversions(brands, this.additionalConversions, false, this.props.cellId));
			});
		}
	}

	setInitConverionFilter() {
		const conversions = this.props.conversions;
		const conversionsData = this.props.conversionsData[this.props.cellId];
		let selectedConversions: any[] = [];

		if (conversionsData && conversions && conversions.length > 0) {
			this.props.brands.forEach((brand: string) => {
				// @ts-ignore
				if (conversionsData) {
					// @ts-ignore
					selectedConversions = [...selectedConversions, ...conversionsData];
					selectedConversions = selectedConversions.filter(item => conversions.indexOf(item.value) !== -1);
				}
			});
		}

		this.setState({ selectedConversions });
	}

	getOptions() {
		let selectConversions: any[] = [];
		const conversionsData = this.props.conversionsData[this.props.cellId];
		if (this.props.brands.length > 0) {
			// @ts-ignore
			if (conversionsData && conversionsData.length > 0) {
				// @ts-ignore
				conversionsData.forEach(conversion => {
					// @ts-ignore
					selectConversions = [...selectConversions, conversion];
				});
			}
		}

		return selectConversions;
	}

	onConversionChange(option: OptionType[]) {
		this.setState({ selectedConversions: option }, () => {
			this.props.updateConfig(["conversions"], [(!option || option.length < 1) ? [] : option.map(item => item.value)]);
		});
	}

	render() {
		return (
			<div className="form-group">
				<label htmlFor="conversion-filter">Conversion</label>
				<Select
					id="conversion-filter"
					className="basic-single"
					classNamePrefix="so-select-sort"
					isSearchable={true}
					isMulti
					value={this.state.selectedConversions}
					options={this.getOptions()}
					onChange={(option) => this.onConversionChange((option as OptionType[]))}
					isLoading={this.props.isLoadingBrands || this.props.isLoadingConversions}
					menuPortalTarget={document.body}
					styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
					isDisabled={this.props.isDisabled}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state: any) => {
	return {
		isLoadingBrands: state.brands.isLoading,
		conversionsData: state.conversions.cellId ? state.conversions.data : [],
		isLoadingConversions: state.conversions ? state.conversions.isLoading : false
	}
};

export default connect(mapStateToProps)(ConversionFilter);